import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import {IoStar, IoStarHalf} from 'react-icons/io5'
import { CartContext } from '../context/CartContext'
import { url } from '../constants'
import './swiper.css'

const CardContainer = styled.div`
    margin-top: 20px;
    display:flex;
    flex-direction:column;
    justify-content:center;
    max-width: 80%;
    .wrapper-div{
        display: flex;
    }
    img {
        border-radius:10px;
    }
    .rating-price-container{
        display:flex;
        justify-content:space-between;
    }
    .planner-content{
        color: gray;
        margin-bottom: 10px;
    }
    h6{
        margin-top:10px;
        font-size:14px;
        color:gray;
    }
    span{
        color:var(--border) !important;
    }
    button{
    align-self:'center';
    color:white;
    width:100%;
    padding:10px;
    background: rgba(77,75,50,0.72);
    border-radius:5px;
    font-weight:500;
    font-size:16px;
    border: 1px solid rgba(77,75,50,0.72);
    transition: all 0.5s ease-in;
    &:hover{
        background: #FCDA8B;
        border: 1px solid #FCDA8B;
        color:black;
        font-weight:500;
        cursor:pointer;
    }
    }

    @media screen and (max-width:768px){
        margin-top: -30px;
        .wrapper-div {
            flex-direction: column;
        }

        .image-container {
            justify-content: center;
            display: flex;
            /* flex-direction: column; */
            width: 100%;
            align-items: center;
            margin-bottom: 20px;

            img {
                margin-right: 0px;
                /* width: 100%; */
            }
            h6{
                display: none;
            }
        }

        .add-to-cart-btn{
            margin: 20px auto;
        }
    }
`
const Card = ({productId, images, title, category, stars, description, price}) => {
    const {addToCart} = useContext(CartContext)
    const [currentIndex, setCurrentIndex] = useState(0);
    const [touchStart, setTouchStart] = useState(0);

    const handleSwipe = (direction) => {
      if (direction === "left" && currentIndex > 0) {
        setCurrentIndex(currentIndex - 1);
      } else if (direction === "right" && currentIndex < images.length - 1) {
        setCurrentIndex(currentIndex + 1);
      }
    };
  
    const handleTouchStart = (e) => {
      setTouchStart(e.touches[0].clientX);
    };
  
    const handleTouchEnd = (e) => {
      const touchEnd = e.changedTouches[0].clientX;
      if (touchStart - touchEnd > 50) {
        handleSwipe("right");
      } else if (touchEnd - touchStart > 50) {
        handleSwipe("left");
      }
    };
  
    
  return (
    <CardContainer>
        <div className='wrapper-div'>
            <div className="image-container swipe-container" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
                <div className='d-flex column'>
                    <div
                        className="image-wrapper"
                        style={{
                        transform: `translateX(-${currentIndex * 100}%)`,
                        }}
                    >
                        {images.map((img, index) => (
                            <img key={index} src={url + img} alt={`Slide ${index + 1}`} />
                        ))}
                    </div>
                    <h6>{category ? category : 'Uncategorized'}</h6>
                    <div className='button-container d-flex items-center space-between '>
                        <button onClick={() => handleSwipe("left")} className="swipe-btn left">
                            &#8249;
                        </button>
                        <button onClick={() => handleSwipe("right")} className="swipe-btn right">
                            &#8250;
                        </button>
                    </div>
                </div>
            </div>
            <div>
                <span><IoStar /><IoStar /><IoStar /><IoStar /><IoStarHalf /></span>
                <h5>{title}</h5>
                <div
                    className="planner-content"
                    dangerouslySetInnerHTML={{ __html: description }}
                ></div>
                <button className='add-to-cart-btn' onClick={()=>addToCart(title, url + images?.[0], productId, price)}>Add to Cart ( € {price} )</button>
            </div>
        </div>
    </CardContainer>
  )
}

export default Card